import * as Redux from 'redux'
import * as Modal from '../../../components/modal'
import * as Request from '../../../request'
import * as Attributes from '../attributes'
import * as Members from '../constants'
import * as Actions from './actions'
import * as Constants from './constants'
import * as Types from './types'

type AttributeActions = Actions.UpdateAttributeAction & Actions.EditAttributeAction & Request.SuccessAction
const modalReducer = (sourceReducer: Redux.Reducer<Modal.State<Types.ModalData>>) =>
  (state: Types.ModalState, action: AttributeActions) => {
  switch (action.type) {
    case Constants.ADD_MEMBER_ATTRIBUTE:
      return {
        ...state,
        data: {
          ...state.data,
          attributes: [
            ...state.data.attributes,
            {
              index: state.data.attributes.length,
              is_editing: true,
              name: '',
              value: '',
            },
          ],
        },
      }
    case Constants.CLICK_MEMBER_ATTRIBUTE:
      return {
        ...state,
        data: {
          ...state.data,
          attributes: [
            ...state.data.attributes.map(
              (e: Attributes.Attribute) => ({
                ...e,
                is_editing: e.index === action.index,
              }),
            ),
          ],
        },
      }
    case Constants.EDIT_MEMBER_ATTRIBUTE:
      return {
        ...state,
        data: {
          ...state.data,
          attributes: [
            ...state.data.attributes.slice(0, action.index),
            {
              ...state.data.attributes[action.index],
              name: action.field.name,
              value: action.field.value,
            },
            ...state.data.attributes.slice(action.index + 1),
          ],
        },
      }
    case Request.successConstant(Members.FETCH_MEMBERS):
      return {
        ...state,
        availableAttributes: action.payload.response.attributes,
      }
    case Modal.toggleModalConstant(Constants.ADD_MEMBER):
      if (!state.isOpen) {
        return {
          ...state,
          data: Constants.newMemberState(state.availableAttributes),
          isOpen: true,
          isSubmitting: false,
          submitSuccess: false,
        }
      } else {
        return {
          ...state,
          isOpen: false,
        }
      }
    default:
      return sourceReducer(state, action)
  }
}

const addModalReducerEvent: Modal.ReducerEvent<Types.ModalData> = {
  initializeState: () => Constants.emptyModalState,
  requestEvent: Constants.ADD_MEMBER,
}

export const reducer = modalReducer(Modal.reducer(addModalReducerEvent))



// WEBPACK FOOTER //
// ./src/pages/members/add-modal/reducer.ts